// Load jQuery
import $ from 'jquery';
window.$ = window.jQuery = $;

// Load BS
require('bootstrap');

//Load Libraries
require('flatpickr/dist/flatpickr.min');
require('select2/dist/js/select2.full.min');

//Load Modules
require('./modules/accordion');
require('./modules/formInputs');
require('./modules/modal');
require('./modules/sideMenu');
require('./modules/alert');